export const formatZip = (value) => {
	const cleaned = value.replace(/\D/g, '').slice(0, 5);

	if (cleaned.length <= 5) return cleaned;
	return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
};
